// Types
import { TooltipSyntheticEventNames } from '../types/TooltipSyntheticEventNames';
/**
 * Dispatches a close tooltip synthetic event
 *
 * @param {HTMLDivElement} subscribedTooltipEventElement
 */
export var dispatchCloseTooltipEventOnThisElement = function (subscribedTooltipEventElement) { return function () {
    subscribedTooltipEventElement === null || subscribedTooltipEventElement === void 0 ? void 0 : subscribedTooltipEventElement.dispatchEvent(new CustomEvent(TooltipSyntheticEventNames.Close));
}; };
//# sourceMappingURL=dispatchCloseTooltipEventOnThisElement.js.map